import React, { Component } from 'react';

class NavBar extends Component {
  render() {
    const button = this.props.buttonPath ? (
      <button className="skip-btn" onClick={() => {}}></button>
    ) : (
      <div />
    );

    return (
      <nav className="ui-widget-header">
        <div className="navbar-content">
          <a
            className="navbar-brand"
            href="https://zengo.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={process.env.PUBLIC_URL + '/images/ZenGo-Logo-On-Light.png'}
              height="40"
              alt="ZenGo Logo"
              style={{ padding: 8 }}
            />
          </a>
          <a
            className="navbar-brand"
            href="https://app.adjust.com/muzqwc3"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              type="button"
              className="primary-btn btn-block"
              style={{ margin: 8 }}
              href
            >
              Get ZenGo
            </button>
          </a>
        </div>
      </nav>
    );
  }
}
export default NavBar;
